import { useState, useEffect } from 'react';
import { authClient } from '../lib/authClient';
import { Companies, Profiles } from '../services/employeeApi';

/**
 * Hook to get current user profile with role and company_id
 * @returns {Object} { currentUser, loading, error }
 */
export const useCurrentUser = () => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadCurrentUser = async () => {
      try {
        setLoading(true);
        setError(null);

        const session = await authClient.getSession();
        if (!session?.user?.id) {
          setError('Not authenticated');
          setLoading(false);
          return;
        }

        const userId = session.user.id;

        // Get current user profile
        const profile = await Profiles.getMyProfile(userId);
        if (profile?.company_id) {
          try {
            const company = await Companies.get(profile.company_id);
            const name = company?.name && String(company.name).trim();
            if (name) profile.company_name = name;
          } catch (companyErr) {
            console.error('Error loading company name:', companyErr);
          }
        }
        setCurrentUser(profile);
      } catch (err) {
        console.error('Error loading current user:', err);
        setError(err.message || 'Failed to load user profile');
      } finally {
        setLoading(false);
      }
    };

    loadCurrentUser();
  }, []);

  return { currentUser, loading, error };
};

